$(document).ready(function () {
	if ($(window).width() > 992 ) {  
		const img = document.getElementById('art-img');
		if (!img) return;

		let scale = 1;
		const minScale = 1;
		const maxScale = 6;
		const scrollZoomStep = 0.8; // zoom step for scroll
		const clickZoomStep = 0.8;  // zoom step for click
		const smallClickStep = 0.3; // small zoom for mousedown
		const hoverZoomStep = 0.3;  // small zoom on hover
		let originX = 50;
		let originY = 50;

		function updateTransform() {
			img.style.transformOrigin = `${originX}% ${originY}%`;
			img.style.transform = `scale(${scale})`;
		}

		// Hover zoom while the mouse is over the image
		img.addEventListener('mousemove', (e) => {
			const rect = img.getBoundingClientRect();
			originX = ((e.clientX - rect.left) / rect.width) * 100;
			originY = ((e.clientY - rect.top) / rect.height) * 100;

			// Add small hover zoom
			// if (scale < maxScale) {
			// 	scale += hoverZoomStep;
			// 	scale = Math.min(scale, maxScale);
			// }

			updateTransform();
		});

		// Zoom using scroll
		img.addEventListener('wheel', (e) => {
			e.preventDefault();
			const direction = e.deltaY < 0 ? 1 : -1;
			scale += direction * scrollZoomStep;
			scale = Math.min(Math.max(scale, minScale), maxScale);
			updateTransform();
		}, { passive: false });

		// Zoom using click (significant)
		img.addEventListener('click', (e) => {
			const rect = img.getBoundingClientRect();
			originX = ((e.clientX - rect.left) / rect.width) * 100;
			originY = ((e.clientY - rect.top) / rect.height) * 100;

			scale += clickZoomStep;
			scale = Math.min(scale, maxScale);
			updateTransform();
		});

		// Small zoom when mouse button is held down
		img.addEventListener('mousedown', (e) => {
			const rect = img.getBoundingClientRect();
			originX = ((e.clientX - rect.left) / rect.width) * 100;
			originY = ((e.clientY - rect.top) / rect.height) * 100;

			scale += smallClickStep;
			scale = Math.min(scale, maxScale);
			updateTransform();
		});

		// Reset when mouse leaves the image
		img.addEventListener('mouseleave', () => {
			scale = 1;
			originX = 50;
			originY = 50;
			updateTransform();
		});

		// Reset zoom on double click
		img.addEventListener('dblclick', () => {
			scale = 1;
			originX = 50;
			originY = 50;
			updateTransform();
		});
	}
});